import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type PromptPreviewProps = {
  value: string;
};

export const PromptPreview = ({ value }: PromptPreviewProps) => {
  return (
    <Box
      data-test="deal-prompt-input-preview"
      sx={{
        backgroundColor: 'background.boxDarker',
        borderRadius: 1,
        p: 1.5,
      }}
    >
      <Typography sx={{ mb: 0.5 }}>[{value}]</Typography>
    </Box>
  );
};
